import React from 'react';
import PropTypes from 'prop-types';
import MenuRenderer from 'components/MainMenu/MenuRenderer';

const MainMenu = ({ role, show }) => {
  if (!role || !show) return null;
  return <MenuRenderer userRole={role} show={show} />;
};

MainMenu.propTypes = {
  role: PropTypes.number,
  show: PropTypes.bool
};

export default MainMenu;



// WEBPACK FOOTER //
// ./src/components/MainMenu/index.js